module.exports = __webpack_public_path__ + "img/news8.fb864394.png";